import { SVGProps } from "react";

export const CheckIconCircle = (props: SVGProps<SVGSVGElement>) => (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.875 9.57008L8.30822 12.0714L12.625 7.25" stroke="#3F4067" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
        <circle cx="9.25" cy="9.5" r="7.875" stroke="#3F4067" stroke-width="1.2"/>
    </svg>
);
